import React from 'react';
export function InfoIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M7.99998 10.6663V7.99967M7.99998 5.33301H8.00665M14.6666 7.99967C14.6666 11.6816 11.6819 14.6663 7.99998 14.6663C4.31808 14.6663 1.33331 11.6816 1.33331 7.99967C1.33331 4.31778 4.31808 1.33301 7.99998 1.33301C11.6819 1.33301 14.6666 4.31778 14.6666 7.99967Z"
                stroke="currentColor"
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function SuccessIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M5.99998 7.99967L7.33331 9.33301L9.99998 6.66634M14.6666 7.99967C14.6666 11.6816 11.6819 14.6663 7.99998 14.6663C4.31808 14.6663 1.33331 11.6816 1.33331 7.99967C1.33331 4.31778 4.31808 1.33301 7.99998 1.33301C11.6819 1.33301 14.6666 4.31778 14.6666 7.99967Z"
                stroke="currentColor"
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function WarningIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
            <path
                d="M8 4.99951V7.66618M8 10.3328H8.00667M14.4866 10.9995L9.15329 1.66617C9.037 1.46097 8.86836 1.29029 8.66457 1.17154C8.46078 1.0528 8.22915 0.990234 7.99329 0.990234C7.75743 0.990234 7.52579 1.0528 7.322 1.17154C7.11822 1.29029 6.94958 1.46097 6.83329 1.66617L1.49995 10.9995C1.38241 11.2031 1.32077 11.4341 1.32129 11.6692C1.32181 11.9042 1.38447 12.135 1.50292 12.338C1.62136 12.5411 1.79138 12.7092 1.99575 12.8254C2.20011 12.9415 2.43156 13.0016 2.66662 12.9995H13.3333C13.5672 12.9993 13.797 12.9375 13.9995 12.8204C14.202 12.7032 14.3701 12.5349 14.487 12.3322C14.6038 12.1296 14.6653 11.8998 14.6653 11.6658C14.6652 11.4319 14.6036 11.2021 14.4866 10.9995Z"
                stroke="currentColor"
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function ErrorIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M3.26658 3.26628L12.7332 12.7329M14.6666 7.99967C14.6666 11.6816 11.6819 14.6663 7.99998 14.6663C4.31808 14.6663 1.33331 11.6816 1.33331 7.99967C1.33331 4.31778 4.31808 1.33301 7.99998 1.33301C11.6819 1.33301 14.6666 4.31778 14.6666 7.99967Z"
                stroke="currentColor"
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/utils/icons.js